/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".finger-prints-scan[_ngcontent-%COMP%]{padding-top:8px}.finger-prints-scan[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#231d19;font-size:24px;font-weight:300;letter-spacing:0;line-height:32px}.finger-prints-scan[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-size:16px;letter-spacing:0;line-height:24px;color:#323237;margin-top:24px;font-family:\"Itau Text\";font-weight:400}.finger-prints-scan[_ngcontent-%COMP%]   .animation[_ngcontent-%COMP%]{margin-top:40px;margin-bottom:24px}"];
export { styles as styles };
